export const CSV_COLUMN_HEADER_DELIMETER = "|"

export const BLANK_CSV_COLUMN_VALUE = ""
